import Vue from "vue";
import App from "@/App.vue";
import router from "./router";
import store from "./store";
import VueI18n from "vue-i18n";
import { createI18n } from "vue-i18n-composable";
import locale from "@/locale/index";
import elementEnLocale from "element-ui/lib/locale/lang/en"; // element-ui lang
import elementZhLocale from "element-ui/lib/locale/lang/zh-CN"; // element-ui lang
import ElementUI, { MessageBox } from "element-ui";
import "./style/element-variables.scss";

import { post_file, post_fileUrl } from "./newwork/network.js";
import { postWithToken } from "@/api/http";

Vue.use(VueI18n);

Vue.prototype.$messageBox = MessageBox;
Vue.prototype.$post = postWithToken;
Vue.prototype.$post_notoken = postWithToken;
Vue.prototype.$post_file = post_file;
Vue.prototype.$post_fileUrl = post_fileUrl;

Vue.config.productionTip = false;

Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value),
  size: "small",
});

const messages = {
  en: {
    ...locale.en,
    ...elementEnLocale,
  },
  zh: {
    ...locale.zh,
    ...elementZhLocale,
  },
};

const i18n = createI18n({
  locale: store.state.language,
  messages,
});

import directive from "@/directive";
directive.install(Vue);

// 谷歌109版本移除Event.path, 做兼容处理
Object.defineProperty(Event.prototype, "path", {
  get() {
    return this.composedPath();
  },
});

const app = new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");

export default app;
